/**
 * The country chooser at `/` (web plan W5.7 / MW10), served only while
 * `LOCALE_CHOOSER` is on and a second country is launched (`chooserLive`): one
 * link to each launched country's home. It is the `x-default` of every locale
 * home, carries the same `Organization` + `WebSite` markup, and never redirects
 * by language, cookie or IP (master D-11): the visitor picks.
 */
import { Link } from 'react-router-dom';
import { PageHead } from '@/components/seo/PageHead';
import { useTranslate } from '@/i18n/LocaleLanguage';
import { ccToFlag } from '@/lib/countryFlag';
import { LOCALES } from '@/seo/locales';
import { chooserHead } from '@/seo/templates';
import { localePath } from '@/seo/urls';

export default function CountryChooserPage() {
  const t = useTranslate();
  const head = chooserHead({ t });
  return (
    <div className="mx-auto max-w-3xl px-4 py-10 md:py-16">
      <PageHead head={head} />
      <h1 className="text-center text-2xl font-extrabold tracking-tight text-ink md:text-3xl">{head.h1}</h1>
      <p className="mt-3 text-center text-ink-secondary">{t('chooser:page.intro')}</p>
      <nav aria-label={t('chooser:page.list')} className="mt-8">
        <ul className="grid gap-3 sm:grid-cols-2">
          {LOCALES.map((locale) => (
            <li key={`${locale.cc}-${locale.lang}`}>
              <Link
                to={localePath(locale)}
                hrefLang={locale.hreflang}
                className="flex items-center gap-3 rounded-2xl border border-line bg-surface px-5 py-4 text-lg font-bold text-ink transition-colors hover:border-primary/40 hover:bg-primary/10 hover:text-primary-strong"
              >
                <span className="text-3xl leading-none" aria-hidden="true">
                  {ccToFlag(locale.cc)}
                </span>
                <span>{t('chooser:page.open', { country: locale.country })}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}
